<template>
  <div class="teaching-supply-elective-apply-main"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="applyInfo">
      <div class="header">
        <el-form size="mini"
                 label-position="left">
          <el-form-item label="选择班级">
            <div class="filter">
              <div class="input">
                <ClazzPicker v-model="filter.clazzId"></ClazzPicker>
              </div>
              <div class="extra">
                <el-button size="mini"
                           type="primary"
                           @click="handleQuery">班级筛选</el-button>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="body">
        <div class="body-cont"
             v-loading="committing"
             element-loading-text="数据提交中，请稍等...">
          <AppScrollbar style="height: 100%">
            <div class="apply-main">
              <DataGrid size="mini"
                        resizable
                        highlight-current-row
                        highlight-hover-row
                        show-overflow="title"
                        show-header-overflow="title"
                        :data="applyInfo.schedules"
                        :row-class-name="rowClassName">
                <DataGridColumn title="学期"
                                field="semester"
                                width="60"
                                align="center"></DataGridColumn>
                <DataGridColumn title="教学点"
                                field="site"
                                width="100"
                                align="center"></DataGridColumn>
                <DataGridColumn title="班级"
                                field="clazz"
                                width="80"
                                align="center"></DataGridColumn>
                <DataGridColumn title="班主任"
                                field="classTeachers"
                                min-width="120"></DataGridColumn>
                <DataGridColumn title="课程"
                                field="course"
                                min-width="120"></DataGridColumn>
                <DataGridColumn title="课程类别"
                                field="courseType"
                                width="80"
                                align="center"></DataGridColumn>
                <DataGridColumn title="学时"
                                field="creditHour"
                                width="50"
                                align="center"></DataGridColumn>
                <DataGridColumn title="学分"
                                field="credit"
                                width="50"
                                align="center"></DataGridColumn>
                <DataGridColumn title="已选人数"
                                width="120"
                                align="center">
                  <template #default="{row}">
                    <LessonCount inline
                                 :lesson-count="row.lessonCount"
                                 :supply-count="row.supplyCount"></LessonCount>
                  </template>
                </DataGridColumn>
                <DataGridColumn title="操作"
                                width="100"
                                align="center"
                                fixed="right">
                  <template #default="{row}">
                    <template v-if="isSupplied">
                      <template v-if="row.id === applyInfo.supplyId">
                        <i class="el-icon-check"></i>
                      </template>
                    </template>
                    <template v-else>
                      <el-radio-group v-model="form.supplyId"
                                      size="mini">
                        <el-radio-button :label="row.id">{{form.supplyId === row.id ? '选中' : '选择'}}</el-radio-button>
                      </el-radio-group>
                    </template>
                  </template>
                </DataGridColumn>
              </DataGrid>
              <template v-if="applyInfo.insteadSchedules && applyInfo.insteadSchedules.length">
                <div class="instead">
                  <div class="header">
                    <TitleGroup title="补修替代"></TitleGroup>
                  </div>
                  <div class="body">
                    <DataGrid size="mini"
                              resizable
                              highlight-current-row
                              highlight-hover-row
                              show-overflow="title"
                              show-header-overflow="title"
                              :data="applyInfo.insteadSchedules"
                              :row-class-name="rowClassName">
                      <DataGridColumn title="学期"
                                      field="semester"
                                      width="60"
                                      align="center"></DataGridColumn>
                      <DataGridColumn title="教学点"
                                      field="site"
                                      width="100"
                                      align="center"></DataGridColumn>
                      <DataGridColumn title="班级"
                                      field="clazz"
                                      width="80"
                                      align="center"></DataGridColumn>
                      <DataGridColumn title="班主任"
                                      field="classTeachers"
                                      min-width="120"></DataGridColumn>
                      <DataGridColumn title="课程"
                                      field="course"
                                      min-width="120"></DataGridColumn>
                      <DataGridColumn title="课程类别"
                                      field="courseType"
                                      width="80"
                                      align="center"></DataGridColumn>
                      <DataGridColumn title="学时"
                                      field="creditHour"
                                      width="50"
                                      align="center"></DataGridColumn>
                      <DataGridColumn title="学分"
                                      field="credit"
                                      width="50"
                                      align="center"></DataGridColumn>
                      <DataGridColumn title="已选人数"
                                      width="120"
                                      align="center">
                        <template #default="{row}">
                          <LessonCount inline
                                       :lesson-count="row.lessonCount"
                                       :supply-count="row.supplyCount"></LessonCount>
                        </template>
                      </DataGridColumn>
                      <DataGridColumn title="操作"
                                      width="100"
                                      align="center"
                                      fixed="right">
                        <template #default="{row}">
                          <template v-if="isSupplied">
                            <template v-if="row.id === applyInfo.supplyId">
                              <i class="el-icon-check"></i>
                            </template>
                          </template>
                          <template v-else>
                            <el-radio-group v-model="form.supplyId"
                                            size="mini">
                              <el-radio-button :label="row.id">{{form.supplyId === row.id ? '选中' : '选择'}}</el-radio-button>
                            </el-radio-group>
                          </template>
                        </template>
                      </DataGridColumn>
                    </DataGrid>
                  </div>
                </div>
              </template>
            </div>
          </AppScrollbar>
        </div>
      </div>
      <div class="footer">
        <template v-if="isSupplied">
          <el-button class="btn-delete"
                     size="mini"
                     type="danger"
                     :disabled="committing"
                     @click="handleDelete">取消补修</el-button>
        </template>
        <template v-else>
          <el-button size="mini"
                     type="primary"
                     :disabled="committing"
                     @click="handleSubmit">提交补修</el-button>
          <el-button size="mini"
                     type="default"
                     @click="handleClose">取消操作</el-button>
        </template>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>补修数据加载失败</div>
        <el-button type="text"
                   @click="loadApplyInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import ClazzPicker from '../../../../../../../biz/picker/clazz'
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
import TitleGroup from '../../../../../../../widgets/custom/TitleGroup'
import DataGrid from '../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../elements/DataGridColumn'
import LessonCount from '../../../../../../../widgets/biz/teaching/LessonCount'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'TeachingSupplyElectiveApplyMain',
  components: {
    ClazzPicker,
    AppScrollbar,
    TitleGroup,
    DataGrid,
    DataGridColumn,
    LessonCount,
    Hint
  },
  props: {
    electiveId: {
      type: String,
      required: true
    },
    extraParams: Object,
    visible: Boolean
  },
  data () {
    return {
      filter: {
        clazzId: ''
      },
      loading: false,
      query: {
        clazzId: ''
      },
      applyInfo: null,
      form: {
        supplyId: ''
      },
      committing: false
    }
  },
  computed: {
    isSupplied () {
      let applyInfo = this.applyInfo
      if (applyInfo) {
        return !!applyInfo.supplyId
      }
    }
  },
  methods: {
    loadApplyInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/supply/elective/applyInfo',
        method: 'post',
        data: this.$qs.stringify(this.$extend({
          postId: this.electiveId
        }, this.query, this.extraParams))
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.applyInfo = response.data['applyInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    rowClassName ({row}) {
      let applyInfo = this.applyInfo
      if (applyInfo) {
        if (row.id === applyInfo.supplyId) {
          return 'theme-text theme-light-bg'
        }
      }
    },
    handleQuery () {
      Object.keys(this.filter).forEach(key => {
        this.$set(this.query, key, this.filter[key])
      })
    },
    handleSubmit () {
      if (!this.form.supplyId) {
        this.$message.warning('请选择要操作的课程')
        return
      }
      this.$confirm('确定要提交本次补修操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.committing = true
        this.$ajax({
          url: '/workspace/manager/teaching/supply/elective/apply/submit',
          method: 'post',
          data: this.$qs.stringify(this.$extend({
            postId: this.electiveId
          }, this.form, this.extraParams))
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                this.$nextTick(() => {
                  this.$emit('hidePopoverAndRefresh')
                })
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.committing = false
        })
      }).catch(() => {})
    },
    handleDelete () {
      this.$confirm('确定要取消本次补修操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.committing = true
        this.$ajax({
          url: '/workspace/manager/teaching/supply/elective/apply/delete',
          method: 'post',
          data: this.$qs.stringify(this.$extend({
            postId: this.electiveId
          }, this.extraParams))
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                this.$nextTick(() => {
                  this.$emit('hidePopoverAndRefresh')
                })
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.committing = false
        })
      }).catch(() => {})
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  },
  mounted () {
    this.loadApplyInfo()
  },
  watch: {
    visible (val) {
      if (val) {
        this.loadApplyInfo()
      }
    },
    query: {
      handler () {
        this.loadApplyInfo()
      },
      deep: true
    },
    applyInfo (val) {
      if (val) {
        Object.keys(this.form).forEach(key => {
          this.form[key] = val[key] || ''
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .teaching-supply-elective-apply-main {
    height: 100%;
    display: flex;
    flex-direction: column;
    & > .header {
      padding: 15px 12px;
      .el-form {
        .el-form-item {
          &:last-child {
            margin-bottom: 0;
          }
          .el-form-item__label {
            font-size: 12px;
          }
          .el-form-item__content {
            .filter {
              display: flex;
              align-items: center;
              & > .input {
                .biz-clazz-picker {
                  width: 240px;
                }
              }
              & > .extra {
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
    & > .body {
      flex: auto;
      position: relative;
      & > .body-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .apply-main {
          padding: 0 12px 15px;
          .instead {
            margin-top: 15px;
            & > .header {
              .title-group {
                & > .main {
                  margin-top: 10px;
                }
              }
            }
            & > .body {
              margin-top: 5px;
            }
          }
          .vxe-table {
            height: 100%!important;
            .vxe-body--row {
              .vxe-body--column {
                .el-radio-group {
                  .el-radio-button {
                    box-shadow: none;
                    .el-radio-button__inner {
                      font-size: 12px;
                      padding: 5px 15px;
                      border-radius: 20px;
                    }
                  }
                }
              }
            }
            .vxe-table--fixed-left-wrapper {
              box-shadow: none;
              &.scrolling--middle {
                border-right: 1px solid rgba(0,0,0,.05);
              }
            }
            .vxe-table--fixed-right-wrapper {
              &.scrolling--middle {
                border-left: 1px solid rgba(0,0,0,.05);
                box-shadow: -2px 0 2px rgba(0,0,0,.05);
              }
            }
          }
        }
      }
    }
    & > .footer {
      flex: none;
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
      .el-button {
        &.btn-delete {
          min-width: 100px;
          border-radius: 20px;
        }
      }
    }
  }
</style>
